import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {DatePipe} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class DataSyncLogsService {

    constructor(private http: HttpClient) {
    }

    // additionalWhereClause
    getLogs(logsFilter: any) {
        const datePipe = new DatePipe('en-US');
        logsFilter.fromDateTime = datePipe.transform(logsFilter.fromDateTime, 'yyyy-MM-dd\'T\'HH:mm:ss');
        logsFilter.toDateTime = datePipe.transform(logsFilter.toDateTime, 'yyyy-MM-dd\'T\'HH:mm:ss');
        logsFilter = JSON.stringify(logsFilter);
        const $logs: Observable<any> = this.http
            .get('logs', {
                params: {
                    logsFilter
                }
            }).pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $logs;
    }

    getLogTypes() {
        const $logTypes: Observable<any> = this.http
            .get('log-types')
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $logTypes;
    }
}
